/**
 *  <blade-gift-bar> — DISPLAY ONLY (9 Sep 2026)
 *
 *  This element paints a progress bar and nothing else. It does not add,
 *  remove or modify a single cart line.
 *
 *  The free-gift promotion belongs to the Kite app, which adds Carnauba Spray
 *  Wax 600ml and discounts it to £0.00. This component previously ran a second,
 *  competing promotion — a different product (Gloss Enhancer, variant
 *  55846764282241) with no discount behind it — so customers were charged
 *  £12.50 for a line the drawer labelled free.
 *
 *  As of 9 Sep the drawer does not render this bar at all (see
 *  snippets/cart-drawer.liquid); the app's own card is the gift UI. The class
 *  is kept, inert, so any cached page that still contains the markup degrades
 *  to a static bar instead of throwing.
 */

/* Shared re-render helper. Swaps the drawer, the cart page and the header
   badge from one round trip, matching the contract in assets/cart.js. */
window.bladeCartRefresh = function (sections) {
  var list = sections || ['cart-drawer', 'cart-bubble', 'main-cart'];
  return fetch(window.location.pathname + '?sections=' + list.join(','))
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var parser = new DOMParser();

      function swap(sectionName, selector, replaceInner) {
        if (!data[sectionName]) return;
        var target = document.querySelector(selector);
        if (!target) return;
        var doc = parser.parseFromString(data[sectionName], 'text/html');
        var source = doc.querySelector(selector);
        if (!source) return;
        if (replaceInner) target.innerHTML = source.innerHTML;
      }

      /* Keep the <cart-drawer> element itself — it carries the open state and
         the theme's OverlayManager reference. Only its contents change. */
      swap('cart-drawer', '#Cart-Drawer .side-panel-inner', true);
      swap('cart-bubble', '.thb-item-count', true);
      swap('main-cart', '.thb-cart-form', true);

      document.dispatchEvent(new CustomEvent('blade:cart:updated'));
      return data;
    });
};

if (!customElements.get('blade-gift-bar')) {
  class BladeGiftBar extends HTMLElement {
    connectedCallback() {
      this.threshold = parseInt(this.dataset.threshold, 10) || 0;
      this.eligible = parseInt(this.dataset.eligible, 10) || 0;
      this.variantId = this.dataset.variantId || '';
      this.inStock = this.dataset.inStock === 'true';
      this.hasGift = this.dataset.hasGift === 'true';
      this.giftKey = this.dataset.giftKey || '';

      this.paint();
    }

    paint() {
      var fill = this.querySelector('.blade-gift-bar--fill');
      if (!this.threshold) return;
      var pct = Math.min(100, Math.round((this.eligible / this.threshold) * 100));
      if (fill) fill.style.width = pct + '%';
      var track = this.querySelector('.blade-gift-bar--track');
      if (track) track.setAttribute('aria-valuenow', pct);
      this.classList.toggle('is-qualified', this.eligible >= this.threshold);
    }

    /* DELIBERATELY NO CART WRITES.
       The Kite app already owns this promotion: it adds Carnauba Spray Wax
       600ml with a real discount so the line bills at £0.00. This component
       used to add a SECOND, different Carnauba (Gloss Enhancer, variant
       55846764282241) with no discount behind it, so the customer was charged
       £12.50 for a line the drawer called free. Reproduced live 9 Sep: a
       £53.00 cart became £65.50 on opening the drawer. Orders #44472 and
       #44475 were affected.

       One promotion, one owner. If this bar is ever reinstated it must read
       the app's state, never write its own line. */
  }

  customElements.define('blade-gift-bar', BladeGiftBar);
}
